export const getCustomVersionName = (name: string) => {
  return name.match(/(?<=\s\d+\s).*/gm)?.[0];
};

export const getDefaultVersionName = (name: string) => {
  return name.match(/^\w+\s\d+/gm)?.[0];
};
